module.exports = __webpack_public_path__ + "img/faproulette-logo.5b8ecc65.png";